import { BaseService } from '../base.service';
import { JobType } from 'src/@core/interfaces/job/job-type.model';
import { HttpClient, HttpParams } from '@angular/common/http';
import { API_JOB_TYPE, GET_QUOTATION } from '../util/api.endpoints';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PageableResponse } from 'src/@core/interfaces/pageable-response';
import * as _ from 'lodash';

declare const JOB_TYPES = 'JOB_TYPES';

/**
 * Service response for fetch, create, update and delete the Job Type.
 */
@Injectable({
  providedIn: 'root'
})
export class JobTypeService extends BaseService<JobType> {
  constructor(private http: HttpClient) {
    super(http, API_JOB_TYPE);
  }

  getTotalJobType(data: any): Observable<any> {
    const url = API_JOB_TYPE + '/count';
    let params = new HttpParams();
    // need to set params to send
    return this.http.get<any>(url, { params });
  }

  // fetch Quotetions
  fetchQuote(page: number, size: number, sort: string, order: string, searchList?: any[], cacheKey?: any): Observable<PageableResponse<any>> {
    let params = new HttpParams();
    let url = GET_QUOTATION + '?page=' + page;

    if (size != null) {
      url += '&size=' + size;
    }

    if (order !== 'desc') {
      order = 'asc';
    }
    if (sort != null) {
      url += ('&sort=' + sort + ',' + order);
    } else {
      url += ('&sort=createdOn,desc');
    }

    if (searchList && searchList.length > 0) {
      _.forEach(searchList, (search) => {
        if (search.column && search.content) {
          params = params.append(search.column, search.content);
        }
      });
    }
    return this.http.get<PageableResponse<any>>(url, { params: params });
  }

}
